module.exports = __webpack_public_path__ + "img/absent-color.81de8ae3.png";